import { Api } from '../api';
import { IListagemFornecedora } from 'shared/types';


const getAll = async (org: number, canal: number): Promise<IListagemFornecedora[] | Error> => {
  try {
    const { data, status } = await Api.get(`/Orgs/${org}/Canais/${canal}/Fornecedores`);
    if (data) {
      return data;
    }
    if (status === 204){
      return [];
    }

    return new Error('Erro ao listar os registros.');
  } catch (error) {
    return new Error((error as { message: string }).message || 'Erro ao listar os registros.');
  }
};

const getOrg = async (org: number): Promise<IListagemFornecedora[] | Error> => {
  try {
    const { data, status } = await Api.get(`/Orgs/${org}/Fornecedores`);
    if (data) {
      return data;
    }
    if (status === 204){
      return [];
    }

    return new Error('Erro ao listar os registros.');
  } catch (error) {
    return new Error((error as { message: string }).message || 'Erro ao listar os registros.');
  }
};

const get= async (): Promise<IListagemFornecedora[] | Error> => {
  try {
    const { data, status } = await Api.get('Fornecedores');
    if (data) {
      return data;
    }
    if (status === 204){
      return [];
    }

    return new Error('Erro ao listar os registros.');
  } catch (error) {
    return new Error((error as { message: string }).message || 'Erro ao listar os registros.');
  }
};

export const FornecedorasService = {
  getAll,
  getOrg,
  get
};
